import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { FaTimes } from "react-icons/fa";

import "./Checkout.css";

// ======================================================
// Recipient details for Western Union transfers.
// Update these with your actual receiving details.
// ======================================================
const WESTERN_UNION_RECIPIENT = {
  firstName: "Fenil",
  lastName: "Gangani",
  upiAddress: "fenil3103@oksbi",
  address: "Surat, Gujarat, India"
};

const WESTERN_UNION_LINK = "https://www.westernunion.com/";

function WesternUnionDetails() {
  const navigate = useNavigate();
  const [pendingOrder, setPendingOrder] = useState(null);
  const [confirming, setConfirming] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    const order = JSON.parse(localStorage.getItem("pendingOrder"));

    if (!order || order.paymentMethod !== "Western Union") {
      navigate("/checkout/payment");
      return;
    }

    setPendingOrder(order);
  }, [navigate]);

  // Let the user confirm they've completed the transfer — this just
  // moves them forward in the UI. Actual payment confirmation should
  // still happen manually on the admin side once the transfer is
  // verified.
  const handleComplete = () => {
    setConfirming(true);

    // Payment marked done by the user — clear the cart so a fresh
    // session starts clean. (The order itself is already saved in
    // the backend from the Payment step, so this is safe.)
    localStorage.removeItem("cart");

    navigate("/success");
  };

  const handleClose = () => {
    navigate("/checkout/payment");
  };

  if (!pendingOrder) return null;

  return (
    <>
      <Helmet>
        <title>Western Union Transfer Details | Checkout</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div
        style={{
          minHeight: "70vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px"
        }}
      >
        <div
          style={{
            background: "#fff",
            width: "100%",
            maxWidth: 460,
            borderRadius: 10,
            boxShadow: "var(--shadow-md)",
            border: "1px solid var(--border)",
            overflow: "hidden"
          }}
        >
          {/* HEADER */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "14px 20px",
              borderBottom: "1px solid var(--border)"
            }}
          >
            <span style={{ fontSize: 14, color: "var(--text-light)", fontWeight: 500 }}>
              Western Union
            </span>
            <button
              type="button"
              onClick={handleClose}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "var(--text-light)",
                fontSize: 16,
                padding: 4
              }}
              aria-label="Close"
            >
              <FaTimes />
            </button>
          </div>

          {/* BODY */}
          <div style={{ padding: "18px 22px" }}>

            <h2 style={{ fontSize: 22, margin: "0 0 10px", lineHeight: 1.25 }}>
              Instructions to Receive Payment via Western Union
            </h2>

            <p style={{ fontSize: 14, color: "var(--text-light)", margin: "0 0 16px", lineHeight: 1.6 }}>
              To send money from a foreign country to India using UPI, you
              can use the following service:
            </p>

            <div style={{ fontSize: 14, color: "var(--text-dark)", lineHeight: 1.9 }}>

              <p style={{ fontWeight: 700, margin: "0 0 4px" }}>1. Western Union:</p>

              <ul style={{ paddingLeft: 18, margin: 0 }}>

                <li>
                  Go to{" "}
                  <a
                    href={WESTERN_UNION_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#2563eb", textDecoration: "underline" }}
                  >
                    Western Union
                  </a>
                </li>

                <li>Sign up or log in.</li>

                <li>Select India as the recipient country.</li>

                <li>Choose UPI as the transfer method.</li>

                <li>
                  Enter the recipient details:
                  <ul style={{ paddingLeft: 18, margin: "6px 0" }}>
                    <li>First Name: <strong>{WESTERN_UNION_RECIPIENT.firstName}</strong></li>
                    <li>Last Name: <strong>{WESTERN_UNION_RECIPIENT.lastName}</strong></li>
                    <li>UPI Address: <strong>{WESTERN_UNION_RECIPIENT.upiAddress}</strong></li>
                    <li>Address: <strong>{WESTERN_UNION_RECIPIENT.address}</strong></li>
                  </ul>
                </li>

                <li>Confirm and complete the transfer.</li>

              </ul>
            </div>

            <div
              style={{
                marginTop: 16,
                padding: "10px 14px",
                background: "#EEEDFE",
                borderRadius: 8,
                fontSize: 13,
                color: "#3C3489"
              }}
            >
              Order Reference: <strong>{pendingOrder.reference}</strong>
            </div>
          </div>

          {/* FOOTER */}
          <div
            style={{
              display: "flex",
              gap: 10,
              padding: "14px 20px",
              borderTop: "1px solid var(--border)"
            }}
          >
            <button
              type="button"
              className="btn"
              style={{ flex: 1, background: "#f3f4f6", color: "#333" }}
              onClick={handleClose}
            >
              Close
            </button>

            <button
              type="button"
              className="btn"
              style={{ flex: 1 }}
              disabled={confirming}
              onClick={handleComplete}
            >
              {confirming ? "Processing..." : "Done"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default WesternUnionDetails;
